import { TransactionForm } from "../components/TransactionForm";

export const AddTransactionPage = () => {
  return <TransactionForm />;
};
